import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResendEmail } from "../../interfaces/resend-email";
import { resource } from "../../util/resource";
import { DWS } from "@interfaces/dws";
import { AdminLoginAsWineryService } from "./admin-login-as-winery.service";

@Injectable({
  providedIn: "root",
})
export class ResendEmailService {

  constructor(private adminLoginAsWineryService: AdminLoginAsWineryService) {}

  private getAuthHeaders(): { bearer: string } | { headers: { "x-admin-authorization": string } } {
    const adminToken = this.adminLoginAsWineryService.getOriginalAdminToken();
    if (adminToken) {
      const bearerToken = adminToken.replace('Bearer ', '');
      if (bearerToken) {
        return { bearer: bearerToken };
      }
    }
    return { headers: { "x-admin-authorization": "1" } };
  }

  getAllEmailLogs(): Observable<any> {
    const auth = this.getAuthHeaders();
    const req = resource("crm://resend-reservation-email/emails/list");
    if ('bearer' in auth) {
      return req.bearer(auth.bearer).get();
    }
    return req.headers(auth.headers).get();
  }

  getEmailLogs(
    emailType?: string,
    wineryId?: string,
    page: number = 0,
    count: number = 50,
    saleId?: string
  ): Observable<DWS.Page<any>> {
    let params: any = { page, count };
    if (emailType) params.emailType = emailType;
    if (wineryId) params.wineryId = wineryId;
    if (saleId) params.saleId = saleId;
    const auth = this.getAuthHeaders();
    const req = resource("crm://resend-reservation-email/emails/list").params(params);
    if ('bearer' in auth) {
      return req.bearer(auth.bearer).get<DWS.Page<any>>();
    }
    return req.headers(auth.headers).get<DWS.Page<any>>();
  }

  resendEmail(endpoint: string, resendEmail: ResendEmail): Observable<any> {
    const auth = this.getAuthHeaders();
    const req = resource(`crm://resend-reservation-email${endpoint}`);
    if ('bearer' in auth) {
      return req.bearer(auth.bearer).post(resendEmail);
    }
    return req.headers(auth.headers).post(resendEmail);
  }


  resendGiftEmail(payload: ResendEmail & {
    emailLog?: { giftId?: string; sentAt?: string; wineryId?: string };
    giftId?: string;
    saleId?: string;
  }): Observable<any> {
    const emailLog = payload.emailLog || {};
    const body = {
      wineryId: payload.wineryId,
      giftId: emailLog.giftId || payload.giftId || payload.saleId,
      buyerLangIso: payload.forcedLanguage,
      beneficiaryNotifyAt: emailLog.sentAt
        ? emailLog.sentAt.substring(0, 10)
        : undefined,
    };
    const auth = this.getAuthHeaders();
    const req = resource("crm://gifts/resend-emails");
    if ("bearer" in auth) {
      return req.bearer(auth.bearer).postText(body);
    }
    return req.headers(auth.headers).postText(body);
  }

  resendScheduled(resendEmail: ResendEmail): Observable<any> {
    return resource("crm://resend-reservation-email/resend-scheduled")
      .headers({ "x-admin-authorization": "1" })
      .post(resendEmail);
  }

  resendConfirmed(resendEmail: ResendEmail): Observable<any> {
    return resource("crm://resend-reservation-email/resend-confirmed")
      .headers({ "x-admin-authorization": "1" })
      .post(resendEmail);
  }

  resendCompleted(resendEmail: ResendEmail): Observable<any> {
    return resource("crm://resend-reservation-email/resend-completed")
      .headers({ "x-admin-authorization": "1" })
      .post(resendEmail);
  }

  resendRescheduled(resendEmail: ResendEmail): Observable<any> {
    return resource("crm://resend-reservation-email/resend-rescheduled")
      .headers({ "x-admin-authorization": "1" })
      .post(resendEmail);
  }

  resendRevoked(resendEmail: ResendEmail): Observable<any> {
    return resource("crm://resend-reservation-email/resend-revoked")
      .headers({ "x-admin-authorization": "1" })
      .post(resendEmail);
  }
}
